import { render } from "./index.vue?vue&type=template&id=b356baa2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b356baa2&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\Projects\\Web\\era-old.proj\\era.alpha-23-24.local\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.8_vue@3.3.8_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b356baa2"]])

export default __exports__